/**
 * Pre-compiled pt-BR messages for Drawer
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Fechar gaveta` };
